import { render, staticRenderFns } from "./deleteMappingDomain.vue?vue&type=template&id=a81e8e92"
import script from "./deleteMappingDomain.vue?vue&type=script&lang=js"
export * from "./deleteMappingDomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports